// Logika bersama 3 halaman search New_ (New_searchMaterial, New_searchByCharacteristic, New_advanceSearchService)
// yang merender New_CataloguerForm dalam mode lihat saja:
// 1. Context dari `meta` route (router/index.js): formCode (FORM02), itemSource, mcrType pengganti, companies (opsional).
//    TIDAK lewat fetchMcrHeader / mcr_form_type / mcr_form_access (halaman search tidak punya MCR). Dulu dari GeneralSetting
//    `new_search_config` -- setting itu sudah dihapus dari seeder, jadi pindah ke meta route (2026-10-12).
// 2. Form config dimuat (mcr/fetchFormConfig) SEBELUM New_CataloguerForm dirender.
// 3. Daftar hasil search dari query URL + infinite scroll -> store allMcrItem (sama seperti CataloguerForm lama).
//
// Halaman pemakai cukup mendefinisikan yang beda per halaman:
// - method `searchRequest(params)`        -> promise service search (endpoint daftar)
// - method `readQuery(query)`              -> smFormData dari query URL
// - method `buildSearchParams(overrides)`  -> params request (format tiap endpoint beda)
// - method `mapSearchRow(row)` (opsional)  -> normalisasi 1 baris response
// - computed `searchColumns`               -> kolom tabel (layout, hardcode di Vue)
import api from '@/helpers/api';

export default {
	data() {
		return {
			searchContext: null,
			searchContextError: '',
			searchReady: false,
			listLoading: false,
			smFormData: {},
			smPagination: { current_page: 1, per_page: 10, hasMore: true, loadingMore: false },
		};
	},
	computed: {
		sessionUser() {
			try { return JSON.parse(localStorage.getItem('userAuth') || '{}')?.user || {}; } catch { return {}; }
		},
		companyCode() {
			return this.sessionUser.company_code || '';
		},
		clientCode() {
			return this.sessionUser.client_code || '';
		},
	},
	watch: {
		// Navbar search mengganti query di route yang sama (komponen tidak di-mount ulang).
		'$route.query'(to, from) {
			if (!this.searchReady || JSON.stringify(to) === JSON.stringify(from)) return;
			if (Object.keys(to).length === 0) return;
			this.loadFromURL();
		},
	},
	async mounted() {
		// Kosongkan daftar sisa halaman sebelumnya (mis. item MCR) sebelum form dirender.
		this.$store.dispatch('mcr/storeAllMcrItem', []);
		this.$store.commit('mcr/setSelectedMcrItem', null);

		this.resolveSearchContext();
		if (!this.searchContext) return;
		try {
			await this.$store.dispatch('mcr/fetchFormConfig', this.searchContext.form_code);
		} catch (error) {
			console.error('Failed to fetch form config:', error);
			this.searchContextError = 'Form config untuk halaman ini gagal dimuat.';
			return;
		}
		this.searchReady = true;
		this.loadFromURL();
	},
	methods: {
		// Context dari meta route halaman ini. Bentuknya sama dengan baris new_search_config dulu (form_code, item_source,
		// mcr_type), jadi New_CataloguerForm (prop search-context) tidak berubah.
		resolveSearchContext() {
			const meta = this.$route.meta || {};
			if (!meta.formCode) {
				this.searchContextError = 'Halaman ini belum dikonfigurasi (meta.formCode di router).';
				return;
			}
			if (Array.isArray(meta.companies) && !meta.companies.includes(this.companyCode)) {
				this.searchContextError = 'Halaman ini belum dikonfigurasi untuk company Anda.';
				return;
			}
			this.searchContext = {
				company: this.companyCode,
				route: this.$route.name,
				form_code: meta.formCode,
				item_source: meta.itemSource || '',
				mcr_type: meta.mcrType || '',
			};
		},
		loadFromURL() {
			const query = this.$route.query;
			this.smFormData = this.readQuery(query);
			this.smPagination.current_page = query.page ? parseInt(query.page, 10) : 1;
			if (query.per_page) this.smPagination.per_page = parseInt(query.per_page, 10);
			this.smPagination.hasMore = true;
			this.performSearch(this.buildSearchParams({
				page: this.smPagination.current_page,
				per_page: this.smPagination.per_page,
			}));
		},
		loadMore() {
			if (this.smPagination.loadingMore || !this.smPagination.hasMore) return;
			this.performSearch(this.buildSearchParams({
				page: this.smPagination.current_page + 1,
				per_page: this.smPagination.per_page,
			}), { append: true });
		},
		// append=true dipakai infinite scroll -- menambah baris ke daftar yang sudah ada, tidak menggantinya.
		async performSearch(params, { append = false } = {}) {
			if (append) {
				if (this.smPagination.loadingMore || !this.smPagination.hasMore) return;
				this.smPagination.loadingMore = true;
			} else {
				this.listLoading = true;
			}
			try {
				const body = await api(this, this.searchRequest(params), false);
				const rows = (body?.data?.rows || []).map((row) => (this.mapSearchRow ? this.mapSearchRow(row) : row));
				const current = this.$store.state.mcr.allMcrItem || [];
				const baseIndex = append ? current.length : 0;
				const newItems = rows.map((row, idx) => ({ ...row, index: baseIndex + idx }));
				if (!append) this.$refs.cataloguerForm?.resetSelection();
				this.$store.dispatch('mcr/storeAllMcrItem', append ? [...current, ...newItems] : newItems);
				this.smPagination.current_page = params.page || this.smPagination.current_page;
				this.smPagination.hasMore = rows.length >= this.smPagination.per_page;
			} catch (error) {
				console.error('Search failed:', error);
				if (!append) this.$store.dispatch('mcr/storeAllMcrItem', []);
			} finally {
				if (append) this.smPagination.loadingMore = false;
				else this.listLoading = false;
			}
		},
		// Dipakai search-material & search-by-characteristic: buang param kosong, `client` sesuai pola lama
		// (selain MIND-ID dikunci ke client user, MIND-ID boleh pilih lewat query).
		buildMaterialSearchParams(overrides = {}) {
			const params = {
				...this.smFormData,
				...overrides,
				client: this.companyCode !== 'MIND-ID' ? this.clientCode : this.$route.query.client,
			};
			Object.keys(params).forEach((key) => {
				if (params[key] === '' || params[key] == null) delete params[key];
			});
			return params;
		},
	},
};
